const api = {
  // 免登录获取token
  getShareToken: '/monitor_query/public/get_project_dashboard_token',
  // 获取项目信息
  getProjectInfo: '/organizational/get_project_info',
  // 获取在线率
  getOnlineRate: '/organizational/describe_device_realtime_stat',
  // 分布图静态数据
  getSpreadStaticData: '/monitor_query/list_project_crane_distribution',
  // 分布图动态数据
  getSpreadRealData: '/monitor_query/crane_real_time_data',
  // 获取塔机参数
  getProCraneStruct: '/monitor_query/list_project_crane_info',
  // 获取萤石云的token
  getYsToken: '/video/get_yingShi_token',
  // 获取项目的视频列表
  getProVideoList: '/organizational/list_project_real_time_video',
  // 获取行为风险和机体风险
  getOperationMonitorHomeStat: '/monitor_risk/operation_monitor_home_statistics',
  // 获取风险排名
  getListRiskRank: '/monitor_risk/list_risk_rank',
  // 获取行为风险详情列表
  getBehavioralRiskDetail: '/monitor_risk/list_behavioral_risk_detail',
  // 获取机体风险详情列表
  getBodyRiskDetail: '/monitor_risk/list_crane_body_risk_detail'
}
export default api



// WEBPACK FOOTER //
// ./src/api/index.js